import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import * as y from "react";
import { useFormContext as k } from "react-hook-form";
import { B as V } from "./Button.Ccj-dDdM.js";
import { d as $, e as H, f as M, b as B, g as T } from "./Form.LdCd9gH2.js";
import { c as j } from "./index.CxSWpsOB.js";
import { f as g } from "./format._HymmFPq.js";
import { C as Z } from "./Calendar.8LtDUeu3.js";
import { P as E, d as v, c as z } from "./Popover.IWkkIIzd.js";
const I = (r, e) => /* @__PURE__ */ t.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: e, ...r, children: /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M7.5 2.75a.75.75 0 0 0-1.5 0V3H4.25A2.25 2.25 0 0 0 2 5.25v9.5A2.25 2.25 0 0 0 4.25 17h11.5A2.25 2.25 0 0 0 18 14.75v-9.5A2.25 2.25 0 0 0 15.75 3H14v-.25a.75.75 0 0 0-1.5 0V3h-5v-.25ZM4.25 4.5H6v.75a.75.75 0 0 0 1.5 0V4.5h5v.75a.75.75 0 0 0 1.5 0V4.5h1.75a.75.75 0 0 1 .75.75V7h-13V5.25a.75.75 0 0 1 .75-.75Zm-.75 4h13v6.25a.75.75 0 0 1-.75.75H4.25a.75.75 0 0 1-.75-.75V8.5Z" }) }), F = y.forwardRef(I), N = (r) => r ? "from" in r : !1, C = (r, e, a = "PPP") => N(r) ? !r.from || !r.to ? e || "Select a date range" : `${g(r.from, "PPP")} - ${g(r.to, "PPP")}` : Array.isArray(r) ? r?.length ? r.map((n) => g(n, "PPP")).join(", ") : e || "Select dates" : r ? g(r, a) : e || "Select a date", p = (r) => N(r) ? r.from || r.to : Array.isArray(r) ? r.length > 0 : !!r, D = (r) => r && typeof r == "object" && "y" in r && "m" in r && "d" in r ? new Date(r.y, r.m - 1, r.d) : r, L = ({
  dateFormat: r,
  value: e,
  onValueChange: a,
  trigger: n,
  calendarProps: d,
  triggerProps: i,
  fullWidth: f,
  placeholder: l,
  popoverProps: c,
  testId: s = "date-picker",
  disabled: m,
  displayCalendarIcon: o = !0
}) => /* @__PURE__ */ t.jsxs(E, { ...c, children: [
  /* @__PURE__ */ t.jsx(v, { asChild: !0, children: n || /* @__PURE__ */ t.jsx(V, { variant: "outline-1", appearance: "white", prefix: o ? /* @__PURE__ */ t.jsx(F, { className: "tw-text-gray-900" }) : null, fullWidth: f, alignment: "left", truncate: !0, disabled: m, testId: s ? `${s}-trigger` : void 0, ...i || {}, className: j("tw-body-2 hover:tw-bg-base-white", {
    "tw-text-gray-600": !p(e)
  }, i?.className), children: C(e, l, r) }) }),
  /* @__PURE__ */ t.jsx(z, { className: "tw-w-auto tw-p-0", align: "start", children: /* @__PURE__ */ t.jsx(Z, { mode: "single", selected: e, onSelect: a, ...d || {} }) })
] }), A = y.forwardRef(({
  errorMsg: r,
  fullWidth: e,
  readOnly: a,
  disabled: n,
  value: d,
  placeholder: i,
  dateFormat: f,
  displayCalendarIcon: l = !0,
  formatValue: c,
  ...s
}, m) => {
  const o = D(d), x = c && p(o) ? c(o) : C(o, i, f);
  return /* @__PURE__ */ t.jsx(V, { variant: "outline-1", appearance: "white", prefix: l ? /* @__PURE__ */ t.jsx(F, { className: "tw-text-gray-900" }) : null, fullWidth: e, disabled: n, truncate: !0, ref: m, ...s, className: j("tw-justify-start tw-text-left tw-body-2 tw-max-w-full hover:tw-bg-base-white", s?.className, {
    "tw-pointer-events-none": a,
    "tw-text-gray-600": !p(o),
    "tw-border-red-800": !!r
  }), children: /* @__PURE__ */ t.jsx("span", { className: "tw-truncate", "data-testid": s.testId && `${s.testId}-value`, children: x }) });
});
A.displayName = "DatePickerFieldTrigger";
const Y = ({
  name: r = "date",
  calendarProps: e,
  fullWidth: a,
  label: n,
  subcopy: d,
  placeholder: i,
  note: f,
  onValueChange: l,
  className: c,
  disabled: s,
  readOnly: m,
  triggerProps: o,
  popoverProps: x,
  testId: h,
  required: b,
  dateFormat: u,
  displayCalendarIcon: P,
  formatValue: R
}) => {
  const {
    control: S
  } = k();
  return /* @__PURE__ */ t.jsx($, { control: S, name: r, render: ({
    field: w
  }) => /* @__PURE__ */ t.jsxs(H, { disabled: s, readOnly: m, className: j({
    "tw-w-full tw-flex-1": a
  }, c), children: [
    !!n && /* @__PURE__ */ t.jsx(M, { subcopy: d, required: b, children: n }),
    /* @__PURE__ */ t.jsx(L, { testId: h, dateFormat: u, popoverProps: x, displayCalendarIcon: P, calendarProps: Object.assign({
      selected: D(w.value),
      onSelect: l || w.onChange
    }, e || {}), trigger: /* @__PURE__ */ t.jsx(B, { forwardErrorMsg: !0, children: /* @__PURE__ */ t.jsx(A, { dateFormat: u, fullWidth: a, readOnly: m, disabled: s, value: w.value, placeholder: i, ref: w.ref, testId: h ? `${h}-trigger` : void 0, ...o || {}, displayCalendarIcon: P, formatValue: R }) }) }),
    /* @__PURE__ */ t.jsx(T, { children: f })
  ] }) });
};
export {
  L as D,
  Y as a
};
//# sourceMappingURL=DatePickerField.DDVbOFrz.js.map
